/* Copyright (c) 2020-present CloudIO Inc */

import {
  CommonProps,
  defaultCommonProps,
} from '../../layout/Sidebar/panels/PropertiesView/CommonProperties';
import {
  BaseComponentItem,
  ExpressionValue,
} from '../../registry/Component.type';

export interface SparkLineItem extends BaseComponentItem {
  props: SparkLine;
  type: 'SparkLine';
}
export interface SparkLine extends CommonProps {
  dsalias: string;
  valueAttribute?: string;
  doNotPrefetch?: boolean;
  caption?: ExpressionValue;
  captionFont?: ExpressionValue;
  captionFontSize?: number;
  captionFontColor?: ExpressionValue;
  captionFontBold?: string;
  subCaption?: ExpressionValue;
  subCaptionFont?: ExpressionValue;
  subcaptionFontSize?: number;
  subcaptionFontColor?: ExpressionValue;
  subcaptionFontBold?: string;
  chartWidth?: number;
  chartHeight?: number;

  // Background
  bgColor?: ExpressionValue;

  // Period Configuration
  periodlength?: number;
  periodcolor?: ExpressionValue;
  periodalpha?: number;

  // Anchor Visibility
  drawAnchor?: 'Hide All' | 'Show All' | 'Default';
  showOpenAnchor?: boolean;
  showCloseAnchor?: boolean;
  showHighAnchor?: boolean;
  showLowAnchor?: boolean;
  // Line Appearance
  lineColor?: ExpressionValue;
  lineThickness?: number;
  lineAlpha?: number;

  // Data Points/Anchors
  anchorRadius?: number;
  anchorAlpha?: number;

  // Interactivity
  showTooltip?: boolean;
  plotToolText?: ExpressionValue;

  //trendlines
  startValue?: number;
  endValue?: number;
  thickness?: number;
  alpha?: number;
  color?: ExpressionValue;
  showTrendLine?: boolean;
}

export const defaultValue: Required<SparkLine> = {
  ...defaultCommonProps,
  dsalias: '',
  valueAttribute: '',
  doNotPrefetch: false,
  caption: { type: 'text', value: 'Change Me' },
  captionFont: { type: 'text', value: 'Arial' },
  captionFontSize: 20,
  captionFontColor: { type: 'text', value: '' },
  captionFontBold: '1',
  subCaption: { type: 'text', value: 'Change Me' },
  subCaptionFont: { type: 'text', value: 'Source Sans Pro' },
  subcaptionFontSize: 10,
  subcaptionFontColor: { type: 'text', value: '' },
  subcaptionFontBold: '1',
  chartWidth: 1,
  chartHeight: 1,

  // Background
  bgColor: { type: 'text', value: '' },

  // Period Configuration
  periodlength: 7,
  periodcolor: { type: 'text', value: '' },
  periodalpha: 50,
  // Anchor Visibility
  drawAnchor: 'Default',
  showOpenAnchor: true,
  showCloseAnchor: true,
  showHighAnchor: true,
  showLowAnchor: true,
  // Line Appearance
  lineColor: { type: 'text', value: '#ee8f49' },
  lineThickness: 2,
  lineAlpha: 75,

  // Data Points/Anchors
  anchorRadius: 5,
  anchorAlpha: 100,

  // Interactivity
  showTooltip: true,
  plotToolText: { type: 'text', value: 'Value: $dataValue' },

  //trendline
  startValue: 0,
  endValue: 0,
  color: { type: 'text', value: '#cc0000' },
  thickness: 1,
  alpha: 100,
  showTrendLine: false,
};
